/* eslint camelcase: 0 */
/* globals _, mp */

require(`lodash/extend`);

_.namespace(`mp.widgets.dropdowns`, function(ns) {
  'use strict';

  /**
   * @callback track
   * @param {string} event - event being tracked
   * @param {Object} properties - optional dictionary of event properties to be tracked
   */

  function CohortsDropdownBody() {}
  _.inherit(CohortsDropdownBody, ns.RoundedCheckbox.Body);

  /**
   * Initializes the dropdown body for the cohorts selector.
   * @param {Object} div - containing div for the dropdown
   * @param {Object} config - specifications for the cohorts dropdown body
   * @param {boolean} [config.collapse=false] - false if you want a min-width, else the box will collapse to fit
   * @param {boolean} [config.emulate_select=true] - true if you want the the title to change when an item is clicked
   * @param {boolean} [config.filterable=true] - true if you allow filtering the options in the searchbox, false otherwise
   * @param {boolean} [config.menu=false] - true when you can reselect an already selected item
   * @param {number} [config.min_width=130] - minimum width on rendering the dropdown
   * @param {boolean} [config.multiple_selections_allowed=false] - true for checkbox, false for single-selection dropdown list
   * @param {number} config.project_id - id of the report
   * @param {boolean} [config.select_first=false] - true if you want the first value to be selected, else false
   * @param {track} [config.track=(() => {})] - tracking function used to record user actions and send them to Mixpanel
   */
  CohortsDropdownBody.prototype.create = function(div, config) {
    config = config || {};
    CohortsDropdownBody.superclass.create.call(this, div, config);

    // Only one cohort is selectable at any time by default
    this.multiple_selections_allowed = config.multiple_selections_allowed;

    this.container.css(`min-width`, ``);
    const content_container = this.container.find(`.content`);
    const search_container = this.container.find(`.search_box_container`);
    $(`<div class="cohorts_header">Cohorts</div>`).insertAfter(search_container);
    const all_users = $(`<div class="rounded_checkbox_item">All Users</div>`);
    all_users.insertAfter(search_container);
    all_users.on(`click`, () => {
      this.deselect_all();
      this.deactivate();
      this.container.trigger(`all-users-selected`);
    });

    this.select_cohorts_button = $(`<div class="select_cohorts_button">Select cohorts</div>`);
    this.select_cohorts_button.insertAfter(content_container);
    this.select_cohorts_button.on(`click`, _.bind(function() {
      this.deactivate();
      this.config.track(`Clicked select cohorts button`);
    }, this));

    // Prevents a ton of events from being triggered when deselecting all
    this.container.on(`dropdown-item-selected dropdown-item-deselected`, _.throttle(_.bind(function() {
      if (this.active) {
        this.container.trigger(`dropdown-item-selection-changed`);
      }
    }, this), 300, {leading: false, trailing: true}));

    this.container.on(`dropdown-item-selection-changed`, _.bind(function() {
      if (!this.label_changed_after_user_action) {
        this.label_changed_after_user_action = _.throttle(function(label) {
          const num_selected_items = _.filter(this.widgets, function(widget) {
            return widget.selected;
          }).length;
          this.config.track(`Selected cohort option`, {
            '# of selected cohorts': num_selected_items,
            'Label': label.title.html(),
          });
        }, 300, {leading: false, trailing: true});
      }
      this.select_cohorts_button.show();
    }, this));

    this.container.on(`body-activated`, _.bind(function() {
      if (this.select_cohorts_button) {
        this.select_cohorts_button.hide();
      }
    }, this));

    return this;
  };

  CohortsDropdownBody.prototype.filter = function(ev, skip_select) {
    CohortsDropdownBody.superclass.filter.call(this, ev, skip_select);
    const predicate = ns.RoundedCheckbox.filter_predicate_from_query(this.search.val());
    if (_.any(this.widgets, function(item) {
      return predicate(item.display_value);
    })) {
      this.container.find(`> :not(.search_box_container, .select_cohorts_button)`).show();
    } else {
      this.container.find(`> :not(.search_box_container, .select_cohorts_button)`).hide();
    }
  };

  CohortsDropdownBody.prototype.label_changed = function(ev, label) {
    if (this.active && this.label_changed_after_user_action) {
      this.label_changed_after_user_action(label);
    }
  };

  CohortsDropdownBody.prototype.scroll_to_selected = function() {
    // Override this method to disable scrolling when selecting an option
  };


  /**
   * Initialize the cohorts selector.
   * @constructor
   * @param {Object} config - specifications for the cohorts selector
   * @param {boolean} [config.multiple_selections_allowed=false] - true for checkbox, false for single-selection dropdown list
   * @param {number} config.project_id - id of the report
   * @param {track} [config.track=(() => {})] - tracking function used to record user actions and send them to Mixpanel
   */
  function CohortsSelectorView(config) {
    this.body_class = CohortsDropdownBody;
    this.class_name = `rounded_checkbox_dropdown cohorts_selector_widget`;

    this.config = {
      ...config,
      multiple_selections_allowed: config.hasOwnProperty(`multiple_selections_allowed`) ? config.multiple_selections_allowed : false,
      track: () => {},
    };

    this.create($(`<div>All Users</div>`), [], this.config);

    this.is_loaded = false;
    this.container.on(`body-deactivated`, _.bind(function() {
      if (this.container.is(`:visible`)) {
        this.on_close();
      }
    }, this));
  }
  _.inherit(CohortsSelectorView, ns.RoundedCheckbox);

  CohortsSelectorView.prototype.select_item = function(item, skip_event) {
    if (!this.config.multiple_selections_allowed && this.selected_items.length > 0) {
      // deselect everything
      this.deselect_all();
    }
    CohortsSelectorView.superclass.select_item.call(this, item, skip_event);
    this.body.select_cohorts_button.show();
  };

  CohortsSelectorView.prototype.is_your_cohort = function(cohort) {
    return cohort[0].created_by && cohort[0].created_by.id === parseInt(mp.report.globals.user_id);
  };

  CohortsSelectorView.prototype.is_visible = function(cohort) {
    return this.is_your_cohort(cohort) || cohort[0].is_visible;
  };

  CohortsSelectorView.prototype.update = function(values, selectedCohortIds=null) {
    const self = this;
    let selectedCohortIdSet;
    if (selectedCohortIds) {
      selectedCohortIdSet = new Set(selectedCohortIds);
    } else {
      selectedCohortIdSet = new Set();
    }
    const filteredValues = values
      .filter((cohort) => (self.is_visible(cohort) || (selectedCohortIdSet.has(cohort[0].id))))
      .sort((c1, _) => self.is_your_cohort(c1) ? -1 : 1);
    CohortsSelectorView.superclass.update.call(this, filteredValues);
    if (!values.length) {
      const cohorts_url = `/report/` + this.config.project_id + `/cohorts`;
      $(`<a href="` + cohorts_url + `" target="_blank" class="new_cohort_link">Create a cohort<svg-icon icon="arrow-right"/></a>`)
        .appendTo(this.body.content);
    }
  };

  CohortsSelectorView.prototype.on_close = function() {
    // gets called when the -visible- CohortsSelectorView closes
    this.container.trigger(`cohorts-selector-closed`);
  };

  CohortsSelectorView.prototype.deselect_dropdown = function() {
    this.body.deselect_all();
  };

  return {
    CohortsSelectorView,
  };
});
